import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { HELP_DOCUMENT_API} from "./apiRoutes";

interface mutateProps {
  id: string;
}

const mutateDeleteHelpDocument = async ({ id }: mutateProps) => {
  return await axiosAuth.delete(`${HELP_DOCUMENT_API}/${id}`);
};

const useDeleteHelpDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteHelpDocument,
    ...queryParams,
  });

export default useDeleteHelpDocumentMutation;
